import { render } from "./FaqsArea.vue?vue&type=template&id=164bdb9c"
import script from "./FaqsArea.vue?vue&type=script&lang=js"
export * from "./FaqsArea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__